import { render, staticRenderFns } from "./Handles1.vue?vue&type=template&id=e6be2636&scoped=true&"
import script from "./Handles1.vue?vue&type=script&lang=js&"
export * from "./Handles1.vue?vue&type=script&lang=js&"
import style0 from "./Handles1.vue?vue&type=style&index=0&id=e6be2636&lang=scss&scoped=true&"
import style1 from "./Handles1.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6be2636",
  null
  
)

export default component.exports